import {Pressable, StyleSheet, View} from 'react-native'

import {useChatBubble, useChatBubbleDispatch} from '#/state/chat-bubble'
import {useUnreadMessageCount} from '#/state/queries/messages/list-conversations'
import {atoms as a, useTheme} from '#/alf'
import {Bubble_Stroke2_Corner2_Rounded as BubbleIcon} from '#/components/icons/Bubble'
import {Text} from '#/components/Typography'

export function ChatBubbleButton() {
  const t = useTheme()
  const dispatch = useChatBubbleDispatch()
  const {isBubbleOpen} = useChatBubble()
  const unreadCount = useUnreadMessageCount()

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel="Chat"
      onPress={() => dispatch({type: 'TOGGLE_PANEL'})}
      style={({hovered, pressed}: any) => [
        styles.button,
        {
          backgroundColor: isBubbleOpen
            ? t.palette.primary_600
            : t.palette.primary_500,
          transform: [
            {scale: pressed ? 0.92 : hovered ? 1.05 : 1},
          ],
        },
      ]}>
      <BubbleIcon size="lg" fill="#fff" />
      {unreadCount.numUnread && (
        <View style={[styles.badge, {backgroundColor: '#ef4444'}]}>
          <Text style={[styles.badgeText, a.text_xs, {color: '#fff'}]}>
            {unreadCount.numUnread}
          </Text>
        </View>
      )}
    </Pressable>
  )
}

const styles = StyleSheet.create({
  button: {
    width: 56,
    height: 56,
    borderRadius: 28,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
    transition: 'transform 0.15s ease, background-color 0.15s ease',
    pointerEvents: 'auto',
  } as any,
  badge: {
    position: 'absolute' as const,
    top: -2,
    right: -2,
    minWidth: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    paddingHorizontal: 4,
  },
  badgeText: {
    fontWeight: '700' as const,
    fontSize: 11,
    lineHeight: 20,
  },
})
